import { useContext, useState, useEffect, useRef } from 'react';
import { GameStateContext } from '../../Providers/GameStates/GameState.jsx';
import { v4 as uuidv4 } from 'uuid';
import { Box, useTheme } from '@mui/material';
import RowChain, { getChangedIndex } from './RowChain.jsx';

function Lower() {
  const theme = useTheme();
  const { state, goldenIndices, lastAdded } = useContext(GameStateContext);
  const [renderedWords, setRenderedWords] = useState([]);
  const uuidMap = useRef(new Map());
  const completedLinkIndex = state.won
    ? getChangedIndex(state.link, state.lower[state.lower.length - 1]?.[0])
    : -1;

  useEffect(() => {
    if (!state.isInitialized) {
      return;
    }

    const updatedRenderedWords = state.lower.map((item, index) => {
      const word = item[0];
      const changedIndexes = item[1];
      const identifier = `${word}-${index}`;

      let id = uuidMap.current.get(identifier);
      if (!id) {
        id = uuidv4();
        uuidMap.current.set(identifier, id);
      }

      return { id, word, changedIndexes };
    });

    setRenderedWords(updatedRenderedWords);
  }, [state.lower, state.isInitialized]);

  return (
    state.isInitialized && (
      <>
        {[...renderedWords].reverse().map((item, index, words) => (
          <Box
            sx={{
              ...theme.custom.letterRow,
              '--step-color': theme.palette.secondary.main,
            }}
            key={item.id}
            className={`word-row ${
              lastAdded == 'lower' && index === 0 ? 'word-row--slide-up' : ''
            }`}
          >
            <RowChain
              wordLength={state.wordLength}
              incomingIndex={
                index > 0
                  ? words[index - 1].changedIndexes[0]
                  : state.won
                  ? completedLinkIndex
                  : null
              }
              outgoingIndex={
                index < words.length - 1 ? item.changedIndexes[0] : null
              }
              hideIncomingSegment={state.won && index === 0}
            />
            {[...(item.word || [])].map((letter, j) => (
              <Box
                key={j}
                sx={{
                  ...theme.custom.letterBox, // Reuse letter box styles from theme
                  '--aura-color': theme.custom.aura,
                  backgroundColor:
                    index === renderedWords.length - 1
                      ? theme.palette.secondary.main
                      : theme.custom.incorrect,
                  border: `1px solid ${theme.custom.border}`,
                  color: theme.palette.text.primary,
                }}
                className={`letter-box ${
                  index < words.length - 1 && item.changedIndexes[0] === j
                    ? 'letter-box--step-node'
                    : ''
                } ${
                  index === 0 &&
                  ((state.won && completedLinkIndex === j) ||
                    (!state.won && goldenIndices.includes(j)))
                    ? 'letter-box--chain-node letter-box--chain-lower'
                    : ''
                }`}
              >
                {letter}
              </Box>
            ))}
          </Box>
        ))}
      </>
    )
  );
}

export default Lower;
